<div class="date-picker" [formGroup]="form" (click)="toggleDatePicker($event)" #datepicker >
  <input  type="text" [maxlength]="10"  onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57" [formControlName]="formName"  [placeholder]="field.placeholder?field.placeholder:''"   
  [class]="datepicker_serv.getClassName(field.inputClassName)" [class.disabled]="disabled"
  [ngClass]="{'is-invalid':isInValid}">
  <div class="main left-auto" #main *ngIf="!disabled">
    <div class="month" #MONTH>
      <div class="arrows prev-mth" [class]="datepicker_serv.getClassName(field.arrowClassName)"(click)="prevMonth()"></div>
      <div class="mth" [class]="datepicker_serv.getClassName(field.monthClassName)">
        <button type="button" (click)="monthSelected($event)">{{ months[month] }}</button>
        &nbsp;
        <button type="button" (click)="selectYear($event)">{{ year }}</button>
      </div>
      <div class="arrows next-mth" [class]="datepicker_serv.getClassName(field.arrowClassName)"  (click)="nextMonth()"></div>
    </div>
    <div class="days" #DAYS>
      <div class="day"  *ngFor="let d of weekdays">
        {{ d }}
      </div>
      <ng-container *ngFor="let week of days">
        <ng-container *ngFor="let day of week">
          <div class="day" [ngClass]="{
              selected:(this.activeDate!==null)&&
                day.date.toLocaleDateString() ==
                activeDate.toLocaleDateString(),
                today:(day.date.toLocaleDateString() == today.toLocaleDateString()),
              muted:!day.isMonth
            }" [class]="datepicker_serv.getClassName(field.dayClassName)" (click)="selectedDate(day, $event)">{{ day.day }}
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="field.timer">
      <app-timer  [field]='field' (time)="selectedTime($event)"></app-timer>
    </ng-container>
    </div>
    <div class="showallmonth" #showallmonth>
      <app-month [field]='field' (toggle)="monthSelected($event)"></app-month>
    </div>
    <div class="showyear" #showyear>
      <app-year [field]='field' (toggleYear)="yearSelected($event)"></app-year>
    </div>
    <div>
      <button type="button" class="btn reset" (click)="reset()">reset</button>
    </div>
  </div>
</div>
